import React, { Component, PropTypes } from 'react';
import makeControllable from 'components/Mixins/ControlsMixin';
import CourseDetailsComponent from 'components/Dashboard/CourseDetails';
import { DashboardStore, AuthStore, AppStore } from 'stores';
import DashboardActions from 'actions/Dashboard';
import {
  Styles,
  RaisedButton,
  FloatingActionButton,
  Dialog,
  Card,
  CardText,
  CardTitle,
  Paper
} from 'material-ui';
import Message from 'services/Message';
import { mixin, RefluxMixin } from 'Util';
import FullWidthPane from 'components/FullWidthPane';
import * as SvgIcons from 'components/Material/SvgIcons';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';
import * as MaterialIcons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import SearchBarToolbar from 'components/SearchBarToolbar';
import { findDOMNode } from 'react-dom';
import Loader from 'components/Material/Loader';
import debounce from 'oxygen-debounce';
import { translate as _l } from 'oxygen-i18n';

addTranslations({
  ['en-US']: {
    here: 'here',
    New: 'New functionallity add to the platform, read more',
    'New release': '⚡️ New release!',
    'fix tasks': '✅ Improved ui for task management',
    'New statistics': '📈 New statistics page with usage and sales stats',
    'Change password': '🔑 Users can now change password themself in settings',
    'Quiz functionality': '❓Possibility to activate quiz for courses'
  },
  ['sv-SE']: {
    here: 'här',
    New: 'Nya funktioner har lags till i verktyget, läs mer',
    'New release': '⚡️ Nya funktioner!',
    'fix tasks': '✅ Förbättrad gränssnitt för uppgiftshantering',
    'New statistics':
      '📈 Ny statstiksida med försäljningsdata och användardata',
    'Change password':
      '🔑 Användare kan nu själva byta lösenord i inställningar',
    'Quiz functionality':
      '❓Möjligt att aktivera quiz funktionallitet för kurser'
  }
});

const { Spacing } = Styles;
const { ContentAdd, NavigationCancel } = SvgIcons;

const messages = [
  {
    id: 1,
    text: event => (
      <div
        style={{
          margin: 0,
          color: 'white',
          height: '100%',
          position: 'relative'
        }}
      >
        <p>{_l`New release`}</p>
        <li>{_l`fix tasks`}</li>
        <li>{_l`New statistics`}</li>
        <li>{_l`Change password`}</li>
        <li>{_l`Quiz functionality`}</li>
        <NavigationCancel onClick={event} style={styles.cancel} />
      </div>
    )
  },
  {
    id: 2,
    text: event => (
      <div
        style={{
          margin: 0,
          color: 'white',
          height: '100%',
          position: 'relative'
        }}
      >
        <p style={{ margin: 0 }}>
          {_l`New`}{' '}
          <a
            style={{ color: 'white', textDecoration: 'underline' }}
            target="_blank"
            rel="noopener"
            href="https://coursio.com/new/"
          >{_l`here`}</a>
        </p>
        <NavigationCancel onClick={event} style={styles.cancel} />
      </div>
    )
  }
];

const courseControls = {
  menuItems: {
    default: [
      // {menu: 'settings', icon: 'cog'},
      {
        menu: 'edit',
        icon: <MaterialIcons.ContentCreate color={Colors.Colors.fullBlack} />
      }
    ],
    edit: [
      {
        onTouchTap: 'save',
        icon: <MaterialIcons.ActionDone color={Colors.Colors.fullBlack} />
      },
      {
        onTouchTap: 'cancel',
        icon: <MaterialIcons.ContentClear color={Colors.Colors.fullBlack} />
      },
      {
        onTouchTap: 'duplicate',
        icon: (
          <MaterialIcons.ContentContentCopy color={Colors.Colors.fullBlack} />
        )
      },
      {
        onTouchTap: 'delete',
        icon: <MaterialIcons.ActionDelete color={Colors.Colors.fullBlack} />
      }
    ]
  }
};

const CourseDetailsControllable = makeControllable(
  CourseDetailsComponent,
  courseControls
);
const CourseDetails = CourseDetailsComponent;

const css = oxygenCss({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: 32,
    paddingRight: 32,
    '@phone:': {
      paddingLeft: 16,
      paddingRight: 16
    },
    '@tablet:': {
      paddingLeft: 16,
      paddingRight: 16
    }
  }
});

const styles = {
  cancel: {
    height: 28,
    width: 28,
    fill: 'white',
    float: 'right',
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    right: '11px',
    transform: 'translateY(-50%)'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: Spacing.desktopGutter,
    paddingRight: Spacing.desktopGutter
  },
  loader: {
    padding: Spacing.desktopKeylineIncrement
  },
  filterButton: {
    margin: Spacing.desktopGutterMini
  },
  filterButtonContainer: {
    margin: Spacing.desktopGutter,
    marginBottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  ruler: {
    width: '95%',
    fontSize: '1px',
    color: 'grey',
    lineHeight: '1px',
    backgroundColor: 'gainsboro',
    marginTop: '16px',
    marginBottom: '10px'
  }
};

export default class CourseList extends mixin(RefluxMixin, Component) {
  static displayName = 'Dashboard';

  static contextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  constructor() {
    super(...arguments);
    let filter;
    try {
      filter = JSON.parse(localStorage.getItem('dashboardFilter')) || {
        filter: 'All',
        sort: 'LastVisit'
      };
    } catch (e) {
      filter = {
        filter: 'All',
        sort: 'LastVisit'
      };
    }
    const lastSeen = this.getLastSeenNotification();
    const unseenMessages = messages.filter(message => {
      if (message.id <= lastSeen) {
        return false;
      }

      return true;
    });
    let message = null;
    if (unseenMessages.length > 0) {
      message = unseenMessages[0];
    }
    this.state = {
      message,
      shownCourses: 15,
      maxCourses: 15,
      nameCount: 0,
      progress: 0,
      filter: filter.filter,
      sort: filter.sort
    };

    //   (function(w, d, s, g, js, fs) {
    //     g = w.gapi || (w.gapi = {});
    //     g.analytics = {
    //       q: [],
    //       ready: function(f) {
    //         this.q.push(f);
    //       }
    //     };
    //     js = d.createElement(s);
    //     fs = d.getElementsByTagName(s)[0];
    //     js.src = 'https://apis.google.com/js/platform.js';
    //     fs.parentNode.insertBefore(js, fs);
    //     js.onload = function() {
    //       g.load('analytics');
    //     };
    //   })(window, document, 'script');
  }

  setFilter = filter => {
    this.setState({ filter });
    localStorage.setItem(
      'dashboardFilter',
      JSON.stringify({
        filter,
        sort: this.state.sort
      })
    );
  };

  listenToStores() {
    this.listenToStore(AppStore, 'app');
    this.listenToStore(AuthStore, 'auth');
    this.listenToStore(DashboardStore, 'dashboard');
  }

  addCourse() {
    if (this.state.filter != 'All') {
      this.setState({ filter: 'All' });
      DashboardActions.addCourseSkeleton(
        this.context.getIntlMessage('course.new')
      );
    } else {
      DashboardActions.addCourseSkeleton(
        this.context.getIntlMessage('course.new')
      );
    }
  }

  setSort(sort) {
    DashboardActions.setSortMethod(sort);
    this.setState({ sort });
    localStorage.setItem(
      'dashboardFilter',
      JSON.stringify({
        filter: this.state.filter,
        sort
      })
    );
  }

  onDeleteComponent(course) {
    this.curCourse = course;
    this.refs.confirmDialog.show();
  }

  onConfirm() {
    this.refs.confirmDialog.dismiss();
    DashboardActions.removeCourse(this.curCourse, () => {
      Message.info(this.context.getIntlMessage('dashboard.removed'));
    });
  }

  onPageScroll(event) {
    const node = findDOMNode(this);
    if (node.offsetHeight <= event.scrollTop + document.body.offsetHeight) {
      this.setState({ maxCourses: this.state.maxCourses + 3 });
    }
  }

  onScrollToBottom() {
    this.setState({ maxCourses: this.state.maxCourses + 3 });
  }

  gotoCourse(course) {
    if (course.lastViewedPage) {
      this.props.router.push(
        `/course/${course.ownerSlug}/${course.slug}/${course.lastViewedPage}`
      );
    } else {
      this.props.router.push(`/course/${course.ownerSlug}/${course.slug}`);
    }
  }

  componentDidMount() {
    const { editor } = this.state.auth.role;
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    this._pageScrollListener = this.onPageScroll.bind(this);
    findDOMNode(this).addEventListener('scroll', this._scrollListener, false);
    DashboardActions.read(() => {});
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    this.enter = [];
    this.leave = [];
  }

  getLastSeenNotification() {
    const seen = this.getCookie('lastSeenNotification');
    return seen === '' ? 0 : parseInt(seen, 10);
  }

  getCookie(name) {
    const regex = new RegExp(`(?:(?:^|.*;*)${name}*=*([^;]*).*$)|^.*$`);
    return document.cookie.replace(regex, '$1');
  }

  handleClose = () => {
    this.setState({ message: null });
    document.cookie = `lastSeenNotification=${
      this.state.message.id
    };path=/;max-age=31536000`;
  };

  componentWillUpdate() {
    this.enter = [];
    this.leave = [];
  }

  componentWillUnmount() {
    findDOMNode(this).removeEventListener(
      'scroll',
      this._scrollListener,
      false
    );
    if (super.componentWillUnmount) {
      super.componentWillUnmount();
    }
    this.changeSearchText.clear();
  }

  getFloatingActionButtonStyle() {
    let style,
      theme = this.context.muiTheme;
    if (this.context.media === 'phone') {
      style = {
        position: 'fixed',
        right: Spacing.desktopGutter,
        bottom: Spacing.desktopGutter,
        zIndex: 6
      };
    } else {
      style = {
        position: 'fixed',
        right: Spacing.desktopKeylineIncrement / 2,
        top: theme.toolbar.height - theme.floatingActionButton.buttonSize / 2,
        zIndex: 6
      };
      if (this.state.searchEnabled) {
        style.top = style.top + theme.floatingActionButton.buttonSize;
      }
    }
    return style;
  }

  getToolbarStyle() {
    let style = {
      borderStyle: 'none none solid none',
      borderWidth: '1px',
      borderColor: '#DDD',
      backgroundColor: this.context.muiTheme.rawThem.palette.primary1Color
    };
    return style;
  }

  handleSearchTextChange = searchText => {
    this.changeSearchText(searchText);
  };

  changeSearchText = debounce(searchText => {
    if (searchText !== this.state.searchText) {
      this.setState({ searchText });
    }
  }, 300);

  getSearchBarStyle() {
    let style = {
      boxSizing: 'border-box'
    };
    if (this.context.media !== 'phone') {
      style.marginRight = Spacing.desktopKeylineIncrement * 1.5;
      style.marginLeft = Spacing.desktopKeylineIncrement * 1.5;
    }

    return style;
  }

  getCourse(styles) {}

  getStyles() {
    let { courses } = this.state.dashboard;
    let configs = {};
    for (let i = 0; i < courses.length; i++) {
      if (i > this.state.maxCourses) {
        break;
      }
      configs[i] = {
        course: courses[i],
        top: spring(0, presets.gentle)
      };
    }
    return configs;
  }

  getDefaultStyles() {
    let { courses } = this.state.dashboard;
    let configs = {};
    for (let i = 0; i < courses.length; i++) {
      if (i > this.state.maxCourses) {
        break;
      }
      configs[i] = {
        course: courses[i],
        top: spring(200)
      };
    }
    return configs;
  }

  willEnter(index) {
    return {
      top: spring(200),
      course: this.state.dashboard.courses[index]
    };
  }

  willLeave(index, gone) {
    return {
      top: spring(0),
      course: gone.course
    };
  }

  getFilterButtonStyle() {
    const { media } = this.context;
    const phone = media === 'phone';
    return {
      ...styles.filterButton,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'space-around'
      // flexDirection: phone ? 'column' : 'row'
    };
  }

  renderFilterBar() {
    const { filter } = this.state;
    const { media } = this.context;
    const phone = media === 'phone';
    return (
      <div>
        <center>{this.context.getIntlMessage('dashboard.filterTitle')}</center>
        <div style={this.getFilterButtonStyle()}>
          <RaisedButton
            label={this.context.getIntlMessage('dashboard.filterAll')}
            style={styles.filterButton}
            backgroundColor="#ddd"
            onTouchTap={this.setFilter.bind(this, 'All')}
            disabled={filter === 'All'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
          <RaisedButton
            label={this.context.getIntlMessage('dashboard.filterCompleted')}
            style={styles.filterButton}
            backgroundColor="#ddd"
            onTouchTap={this.setFilter.bind(this, 'Completed')}
            disabled={filter === 'Completed'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
          <RaisedButton
            label={this.context.getIntlMessage('dashboard.filterNotCompleted')}
            style={styles.filterButton}
            backgroundColor="#ddd"
            onTouchTap={this.setFilter.bind(this, 'notCompleted')}
            disabled={filter === 'notCompleted'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
          <RaisedButton
            label={this.context.getIntlMessage('dashboard.filterExpiresSoon')}
            style={styles.filterButton}
            backgroundColor="#ddd"
            onTouchTap={this.setFilter.bind(this, 'Soon')}
            disabled={filter === 'Soon'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
        </div>
      </div>
    );
  }

  filterAll() {
    return true;
  }

  filterSoon(course) {
    const expiryDate = new Date(course.expires);
    if (
      Object.prototype.toString.call(expiryDate) === '[object Date]' &&
      !isNaN(expiryDate.getTime())
    ) {
      const now = Date.now();
      if (expiryDate - now < 24 * 60 * 60 * 30 * 1000) {
        return true;
      }
    }
    return false;
  }

  filterCompleted(course) {
    return course.progress >= 1;
  }

  filterNotCompleted(course) {
    return course.progress < 1;
  }

  renderFilterCourses() {
    const { filter, auth } = this.state;
    const { media } = this.context;
    const phone = media === 'phone';
    if (auth.role.editor) {
      return (
        <div style={this.getFilterButtonStyle()}>
          <RaisedButton
            label={this.context.getIntlMessage('dashboard.filterOwn')}
            style={styles.filterButton}
            backgroundColor="#ddd"
            onTouchTap={this.setFilter.bind(this, 'Own')}
            disabled={filter === 'Own'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
          <RaisedButton
            label={this.context.getIntlMessage('dashboard.filterOthers')}
            style={styles.filterButton}
            backgroundColor="#ddd"
            onTouchTap={this.setFilter.bind(this, 'Others')}
            disabled={filter === 'Others'}
            disabledBackgroundColor="#00c9cc"
            disabledLabelColor="#ffffff"
          />
        </div>
      );
    } else {
      return;
    }
  }

  filterOwn(course) {
    return course.canEdit;
  }

  filterOthers(course) {
    return !course.canEdit;
  }

  renderSortingBar() {
    const { filter, sort, auth } = this.state;
    const { media } = this.context;
    const phone = media === 'phone';
    if (auth.role.editor) {
      return (
        <div>
          <div style={styles.ruler}> - </div>
          <center>{this.context.getIntlMessage('dashboard.sortTitle')}</center>

          <div style={this.getFilterButtonStyle()}>
            <RaisedButton
              label={this.context.getIntlMessage('dashboard.sortLastVisit')}
              style={styles.filterButton}
              backgroundColor="#ddd"
              onTouchTap={this.setSort.bind(this, 'LastVisit')}
              disabled={sort === 'LastVisit'}
              disabledBackgroundColor="#00c9cc"
              disabledLabelColor="#ffffff"
            />
            <RaisedButton
              label={this.context.getIntlMessage('dashboard.sortCreated')}
              style={styles.filterButton}
              backgroundColor="#ddd"
              onTouchTap={this.setSort.bind(this, 'Created')}
              disabled={sort === 'Created'}
              disabledBackgroundColor="#00c9cc"
              disabledLabelColor="#ffffff"
            />
          </div>
        </div>
      );
    }
  }

  renderFilterExpendable() {
    const { media } = this.context;
    let renderFilterCourses = this.renderFilterCourses();
    let renderFilterBar = this.renderFilterBar();
    let renderSortingBar = this.renderSortingBar();
    let sortTitle = this.state.sort;
    if (this.state.sort == 'LastVisit') {
      sortTitle = this.context.getIntlMessage('dashboard.sortLastVisit');
    } else if (this.state.sort == 'Created') {
      sortTitle = this.context.getIntlMessage('dashboard.sortCreated');
    }

    let filterTitle = this.state.filter;
    if (this.state.filter == 'notCompleted') {
      filterTitle = this.context.getIntlMessage('dashboard.filterNotCompleted');
    } else if (this.state.filter == 'Soon') {
      filterTitle = this.context.getIntlMessage('dashboard.filterExpiresSoon');
    } else if (this.state.filter == 'Own') {
      filterTitle = this.context.getIntlMessage('dashboard.filterOwn');
    } else if (this.state.filter == 'Others') {
      filterTitle = this.context.getIntlMessage('dashboard.filterOthers');
    } else if (this.state.filter == 'All') {
      filterTitle = this.context.getIntlMessage('dashboard.filterAll');
    }

    return (
      <div>
        <Card
          initiallyExpanded={false}
          style={{ width: '50%', display: 'block', margin: '0 auto' }}
        >
          <CardTitle
            subtitle={
              this.state.auth.role.editor
                ? this.context.getIntlMessage('dashboard.filterTitle') +
                  ': ' +
                  filterTitle +
                  ', ' +
                  this.context.getIntlMessage('dashboard.sortTitle') +
                  ': ' +
                  sortTitle
                : this.context.getIntlMessage('dashboard.filterTitle') +
                  ': ' +
                  filterTitle
            }
            showExpandableButton={true}
          />
          <CardText expandable={true}>
            {renderFilterBar}
            {renderFilterCourses}
            {renderSortingBar}
          </CardText>
        </Card>
      </div>
    );
  }

  render() {
    let confirmActions = [
      { text: 'Cancel' },
      {
        text: this.context.getIntlMessage('Remove'),
        onTouchTap: this.onConfirm.bind(this),
        ref: 'submit'
      }
    ];
    const { editor } = this.state.auth.role;

    let { courses, loading } = this.state.dashboard;
    const children = [];
    const { searchText } = this.state;
    let regexp;
    const { filter } = this.state;
    const filterFunction = this[
      'filter' + filter.charAt(0).toUpperCase() + filter.slice(1)
    ];
    courses = courses.filter(filterFunction);
    if (searchText && searchText !== null) {
      regexp = new RegExp(searchText, 'i');
      courses = courses.filter(course => {
        return course.name.search(regexp) > -1;
      });
    }

    for (let i = 0; i < courses.length; i++) {
      if (i > this.state.maxCourses) {
        break;
      }
      let Element;
      const course = courses[i];
      if (editor && course.canEdit) {
        Element = CourseDetailsControllable;
      } else {
        Element = CourseDetails;
      }
      if (course.mode === 'edit') {
        children.push(
          <Element
            editor={editor}
            key={course.id}
            mode="edit"
            defaultMenu="edit"
            course={course}
            onDeleteComponent={this.onDeleteComponent.bind(this)}
            className={'course'}
            onNavigate={this.gotoCourse.bind(this, course)}
          />
        );
      } else {
        children.push(
          <Element
            editor={editor}
            key={course.id}
            course={course}
            onDeleteComponent={this.onDeleteComponent.bind(this)}
            className={'course'}
            onNavigate={this.gotoCourse.bind(this, course)}
          />
        );
      }
    }

    let floatingActionButton;
    let searchBar;
    if (editor) {
      floatingActionButton = (
        <FloatingActionButton
          style={this.getFloatingActionButtonStyle()}
          onTouchTap={this.addCourse.bind(this)}
        >
          <ContentAdd />
        </FloatingActionButton>
      );
    }
    searchBar = (
      <div style={this.getSearchBarStyle()}>
        <SearchBarToolbar fullWidth onChange={this.handleSearchTextChange} />
      </div>
    );
    const filterExpendable = this.renderFilterExpendable();
    return (
      <AppPage
        className="dashboard"
        header={
          <RulerBar title={this.context.getIntlMessage('menu.Dashboard')} />
        }
      >
        <FullWidthPane onScrollToBottom={this.onScrollToBottom.bind(this)}>
          {(this.state.auth.role.teacher ||
            this.state.auth.role.owner ||
            this.state.auth.role.editor ||
            this.state.auth.role.assistant) &&
            this.state.message && (
              <Paper
                style={{
                  width: '90%',
                  maxWidth: '900px',
                  margin: '20px auto',
                  padding: '1em',
                  backgroundColor: '#6739b7'
                }}
                zDepth={1}
              >
                <div> {this.state.message.text(this.handleClose)} </div>
              </Paper>
            )}
          {searchBar}
          {filterExpendable}
          {!loading && (
            <div className={css.container}>
              {children}
              {courses.length < 1 && !loading && (
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: 32,
                    padding: `${Spacing.desktopGutterMore * 6}px 0`
                  }}
                >
                  {this.context.getIntlMessage('noResults')}
                </div>
              )}
            </div>
          )}
          {loading && (
            <div style={styles.loader}>
              <Loader />
            </div>
          )}
        </FullWidthPane>
        {floatingActionButton}
        <Dialog
          ref="confirmDialog"
          title={this.context.getIntlMessage('dashboard.remove')}
          actions={confirmActions}
          dismissOnClickAway
        />
        {this.props.children}
      </AppPage>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Dashboard.js